import React from "react"
import { UITaskModel } from "../../../../../../../../Models/API/TaskModel"
import { TableColumn } from "resha"
import { Text } from "dash-styled"
import {
    fromNow,
    msToFormattedTime
} from "../../../../../../../../Helpers/Functions/dateFormat"
import { TaskListColumnProps } from "./TaskList"
import { TaskStatusPill } from "../../../Common/TaskStatusPill"
import { sentenceCase } from "../../../../../../../../Helpers/Functions/string"
import upperFirst from "lodash/upperFirst"
import { TaskAssigneeView } from "../TaskAssigneeView"

export const taskColumns: (
    vals: TaskListColumnProps
) => TableColumn<UITaskModel>[] = ({ isCollaboratorTask, appID }) => {
    const cols: TableColumn<UITaskModel>[] = [
        {
            className: "min-w-12",
            renderHeader: () => "Number",
            render: ({ taskNumber }) => (
                <Text component="span" size="sm" className="text-smoke-810">
                    {taskNumber}
                </Text>
            )
        },
        {
            className: "min-w-48",
            renderHeader: () => "Type",
            render: ({ type }) => (
                <Text component="span" size="sm" className="text-smoke-810">
                    {upperFirst(sentenceCase(type))}
                </Text>
            )
        },
        {
            className: "min-w-32",
            renderHeader: () => "Status",
            render: ({ status, correct }) => (
                <TaskStatusPill size="sm" status={status} correct={correct} />
            )
        }
    ]

    cols.push({
        className: "min-w-32 overflow-hidden truncate",
        renderHeader: () => "Assigned to",
        render: model => (
            <Text
                component="span"
                size="sm"
                title={model.labelerUsername}
                className="text-smoke-810"
            >
                <TaskAssigneeView appID={appID} model={model} />
            </Text>
        )
    })

    cols.push({
        className: "min-w-32",
        renderHeader: () => "Completed",
        render: ({ completed }) => (
            <Text component="span" size="sm" className="text-smoke-810">
                {completed === null || completed === undefined
                    ? ""
                    : fromNow(completed.toString())}
            </Text>
        )
    })

    if (isCollaboratorTask) {
        cols.push({
            className: "min-w-32",
            renderHeader: () => "Processing Time",
            render: ({ labelingTime }) => (
                <Text component="span" size="sm" className="text-smoke-810">
                    {labelingTime === null || labelingTime === undefined
                        ? ""
                        : msToFormattedTime(labelingTime)}
                </Text>
            )
        })
    }

    cols.push({
        className: "min-w-24",
        renderHeader: () => "Task ID",
        render: ({ id }) => (
            <Text component="span" size="sm" className="text-smoke-810">
                {id}
            </Text>
        )
    })

    return cols
}
